function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.973,
    height: 59.973,
    viewBox: "0 0 59.973 59.973",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16316",
    d: "M112.794 16.377v41.839a1.758 1.758 0 0 1-1.757 1.757h-49.45a1.758 1.758 0 0 1-1.757-1.757V1.757A1.758 1.758 0 0 1 61.587 0h34.62a1.756 1.756 0 0 1 1.233.506l14.83 14.618a1.758 1.758 0 0 1 .524 1.252z",
    transform: "translate(-52.822)",
    style: {
      fill: "#f4f1f1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16318",
    d: "M373.734 16.377v1.757H360.66a5.276 5.276 0 0 1-5.27-5.271V0h1.757a1.756 1.756 0 0 1 1.233.506l14.83 14.618a1.758 1.758 0 0 1 .524 1.252z",
    transform: "translate(-313.762)",
    style: {
      fill: "#e7dfdd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16319",
    d: "M36.97 136.836v18.447a9.277 9.277 0 0 1-9.27 9.267H9.266A9.277 9.277 0 0 1 0 155.284v-18.448a9.277 9.277 0 0 1 9.266-9.266H27.7a9.277 9.277 0 0 1 9.27 9.266z",
    transform: "translate(0 -112.627)",
    style: {
      fill: "#1b74e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16321",
    d: "m110.409 204.058-5.415-5.415a1.757 1.757 0 0 0-2.485 0l-5.415 5.415a1.757 1.757 0 1 0 2.485 2.485l2.416-2.416v12.76a1.757 1.757 0 0 0 3.514 0v-12.76l2.416 2.416a1.757 1.757 0 0 0 2.485-2.485z",
    transform: "translate(-85.266 -174.92)",
    style: {
      fill: "#f4f1f1"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.5110600960514d2a705d8bd1fcfaaafb.svg";
export { ForwardRef as ReactComponent };